import { render, staticRenderFns } from "./change-delivery-date-modal-component.vue?vue&type=template&id=704cf95c&scoped=true"
import script from "./change-delivery-date-modal-component.vue?vue&type=script&lang=js"
export * from "./change-delivery-date-modal-component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704cf95c",
  null
  
)

export default component.exports